import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, UntypedFormGroup } from '@angular/forms';

@Directive({
  selector: '[startEndDateValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: StartEndDateValidatorDirective, multi: true }]
})
export class StartEndDateValidatorDirective implements Validator {
  @Input() startDateControlName: string = 'startDate';
  @Input() endDateControlName: string = 'endDate';

  validate(group: UntypedFormGroup): { [key: string]: any } | null {
    var start: any;
    var end: any;

    if (this.startDateControlName) {
      start = group.value[this.startDateControlName];
    }

    if (this.endDateControlName) {
      end = group.value[this.endDateControlName];
    }
    

    if (start && start != '' && end && end != '') {
      if (start.setHours(0, 0, 0, 0) > end.setHours(0, 0, 0, 0)) {
        return { 'invalidDate': 'Start date cannot be greater than end date' };
      }
    }

    return null;
  }
}
